module.exports = __webpack_public_path__ + "static/img/5.b7b4d02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/5.png
// module id = 7Bzu
// module chunks = 0